import { action, flow, makeAutoObservable, makeObservable, observable } from "mobx";
import { InputOnChangeData } from "semantic-ui-react";
import { ColDef } from '@ag-grid-enterprise/all-modules';
import { RootStore } from "../../../stores/RootStore";
import { CalibraService } from "../../../services/calibra.service";
import { ManufacturerDescription } from "../../../models/manufacturerDescription";
import { ContentState, convertToRaw, EditorState } from "draft-js";
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

export class ManufacturerInformationStore {        
    manufacturerDescriptionItems: Array<ManufacturerDescription> = [];
    columnDef: Array<ColDef>;
    isItemOpen: boolean = false;
    selectedManufacturerDescriptionItem: ManufacturerDescription = new ManufacturerDescription();
    CalibraService: CalibraService;
    temporaryDescription: string = "";
    editorState = EditorState.createEmpty()
    private RootStore:RootStore;
    constructor(rootStore:RootStore){
        this.RootStore= rootStore;
        makeAutoObservable(this, {
            manufacturerDescriptionItems: observable,
            columnDef: observable,
            isItemOpen: observable,
            temporaryDescription: observable,
            selectedManufacturerDescriptionItem: observable,
            editorState: observable,
            setItemOpenTrue: action,
            setItemOpenFalse: action,
            openSelectedItem: action,            
            updateManufacturerDescriptionItem: action,
            onEditorStateChange: action,
            saveManufacturerDescription: flow,
            getManufacturerDescriptions: flow,
        })

        this.CalibraService = new CalibraService();

        this.columnDef = [
            { field: 'edit', headerName: 'Megtekintés',  maxWidth:120, minWidth:120,
                cellRenderer: 'btnCellRendererOpenItem',
                cellRendererParams: {
                    clicked: (data: any) => {this.openSelectedItem(data.ManufacturerId);},
                    }
                },
            { field: 'ManufacturerName', headerName: 'Gyártó', filter: 'agSetColumnFilter', minWidth: 250, sortable: true },
            { field: 'ModifiedByName', headerName: 'Módosító', filter: 'agSetColumnFilter', minWidth: 220, sortable: true },
            { field: 'ModifiedDateString', headerName: 'Módosítás dátuma', filter: 'agSetColumnFilter', sortable: true },
            { field: 'Description', headerName: 'Leírás', filter: 'agSetColumnFilter', sortable: true },            
        ]
    }    

    updateManufacturerDescriptionItem = (value: string) => {                
        this.temporaryDescription = value;
    }

    setItemOpenTrue = () => {
        this.isItemOpen = true;
    }

    setItemOpenFalse = () => {
        this.isItemOpen = false;
    }

    openSelectedItem = (itemId: number) => {
        this.isItemOpen = true;
        var item = this.manufacturerDescriptionItems.find(x => x.ManufacturerId == itemId)
        this.selectedManufacturerDescriptionItem = item;        
        const blocksFromHtml = htmlToDraft(this.selectedManufacturerDescriptionItem.Description);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);
        this.onEditorStateChange(editorState);
    }

    onEditorStateChange(editorState: any) {
        this.editorState = editorState;


        let cicc2 = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        this.temporaryDescription = cicc2;
        this.updateManufacturerDescriptionItem(cicc2)
    };

    *saveManufacturerDescription() {
        this.setItemOpenFalse();
        this.selectedManufacturerDescriptionItem.Description = this.temporaryDescription;
        this.RootStore.addloading('saveManufacturerDescription');
        yield this.CalibraService.SaveManufacturerDescription(this.selectedManufacturerDescriptionItem);
        this.RootStore.removeLoading('saveManufacturerDescription');
        this.getManufacturerDescriptions();
    }

    *getManufacturerDescriptions() {
        this.RootStore.addloading('getManufacturerDescriptions');
        this.manufacturerDescriptionItems = yield this.CalibraService.GetManufacturerDescriptions();

        this.RootStore.removeLoading('getManufacturerDescriptions');
    }

    get getVodafoneCommissionItemCanBeSaved() {
        // if (this.temporaryDiscount0_5Number === null || this.temporaryDiscount5_25Number === null || this.temporaryDiscount25_50Number === null || this.temporaryDiscount50_InfNumber === null ||
        //     this.temporaryDiscount0_5Number < 0 || this.temporaryDiscount5_25Number < 0 || this.temporaryDiscount25_50Number < 0 || this.temporaryDiscount50_InfNumber < 0) {
        //         return false;
        //     }

        return true;
    }
}